	/*!
 * jQuery UI Touch Punch 0.2.3
 *
 * Copyright 2011–2014, Dave Furfero
 * Dual licensed under the MIT or GPL Version 2 licenses.
 *
 * Depends:
 *  jquery.ui.widget.js
 *  jquery.ui.mouse.js
 */
!function(a){function f(a,b){if(!(a.originalEvent.touches.length>1)){a.preventDefault();var c=a.originalEvent.changedTouches[0],d=document.createEvent("MouseEvents");d.initMouseEvent(b,!0,!0,window,1,c.screenX,c.screenY,c.clientX,c.clientY,!1,!1,!1,!1,0,null),a.target.dispatchEvent(d)}}if(a.support.touch="ontouchend"in document,a.support.touch){var e,b=a.ui.mouse.prototype,c=b._mouseInit,d=b._mouseDestroy;b._touchStart=function(a){var b=this;!e&&b._mouseCapture(a.originalEvent.changedTouches[0])&&(e=!0,b._touchMoved=!1,f(a,"mouseover"),f(a,"mousemove"),f(a,"mousedown"))},b._touchMove=function(a){e&&(this._touchMoved=!0,f(a,"mousemove"))},b._touchEnd=function(a){e&&(f(a,"mouseup"),f(a,"mouseout"),this._touchMoved||f(a,"click"),e=!1)},b._mouseInit=function(){var b=this;b.element.bind({touchstart:a.proxy(b,"_touchStart"),touchmove:a.proxy(b,"_touchMove"),touchend:a.proxy(b,"_touchEnd")}),c.call(b)},b._mouseDestroy=function(){var b=this;b.element.unbind({touchstart:a.proxy(b,"_touchStart"),touchmove:a.proxy(b,"_touchMove"),touchend:a.proxy(b,"_touchEnd")}),d.call(b)}}}(jQuery);

jQuery.noConflict();
jQuery(document).ready(function () {
//  jQuery(document).ready(main);
  var bodyid = jQuery('body').attr('id');
  if (bodyid == "weight-loss-calculator"){jQuery(document).ready(main);}
	// Heart Rate Calculator START
		jQuery('#hartrate-calculate').click(function(){
        var age=jQuery('#age').val();
        var rhr=jQuery('#rhr').val();
        var dpe=jQuery('#dpe').val();
        var mhr=220-age;
        var hrr=mhr-rhr;
        var thr=parseInt(hrr*dpe*0.01)+parseInt(rhr);
        jQuery('#result').css('display','block');
        jQuery('#maximumrate').text(parseInt(mhr)+' BPM');
        jQuery('#targetrate').text(thr+' BPM'); 
        });
	// Heart Rate Calculator END
  
	// Calories Calculator START
    	jQuery('#calculate').click(function(){
	        var sex=jQuery("input[name='sex']:checked").val();
	        var weight=jQuery('#weight').val();
	        var height=jQuery('#height').val();
	        var age=jQuery('#age').val();
	        var activity=jQuery('#activity').val();
	        var weight_kg=weight*0.45359237;
	        var height_cm=height*2.54;
	        switch(sex){
	            case (sex="Male"):
	                var bmr=(13.75*weight_kg)+(5*height_cm)-(6.76*age)+66;
	                break;
	            case (sex="Female"):
	                bmr=(9.56*weight_kg)+(1.85*height_cm)-(4.68*age)+655;
	                break;
	        }
	        switch(activity){
	            case (activity="1"):
	                var dee=bmr*1.2;
	                break;
	            case (activity="2"):
	                dee=bmr*1.375;
	                break;
	            case (activity="3"):
	                dee=bmr*1.55;
	                break;
	            case (activity="4"):
	                dee=bmr*1.725;
	                break;
	            case (activity="5"):
	                dee=bmr*1.9;
	                break;
	        }
	        jQuery('#result').css('display','block');
	        jQuery('#BMR').text(parseInt(bmr)+' Calories');
	        jQuery('#maintain-calaories').text(parseInt(dee)+' Calories');        
		});
    	// Calories Calculator END  
});

    var main = function() {

        // Saves all necessary variables in localstorage to be retrieved later
        function saveVariables() {
            try {
                localStorage.setItem('gender', gender);
                localStorage.setItem('activity', $activityValue);
                localStorage.setItem('age', $ageValue);
                localStorage.setItem('height', $heightValue);
                localStorage.setItem('weight', $weightValue);
                localStorage.setItem('goal', $goalWeight);
                localStorage.setItem('difficulty', $difficultyValue);
                localStorage.setItem('dietRatio', Math.ceil($dietRatio * 100) * -1);
            }
            catch(e) {}
        }


        // Retrieves necessary variables and repopulates the page
        function getVariables(slider, value, init) {
            if(slider === "gender") {
                if(localStorage.getItem(slider)) {
                    gender = localStorage.getItem(slider);
                    calcDailyCalories();
                    checkGenderBox();
                    return;
                } else {
                    gender = init;
                    calcDailyCalories();
                    checkGenderBox();
                    return;
                }
            }
            if(localStorage.getItem(slider)) {
                value = localStorage.getItem(slider);
                return value;
            } else {
                value = init;
                return value;
            }
        }

        // Adds the dynamic fields to each input & populates all values
        function initInputs() {
            getVariables("gender", gender, "female");
            jQuery("#age").text(jQuery("#age-slider").slider("value"));
            jQuery("#height").text(convertHeight(jQuery("#height-slider").slider("value")));
            jQuery("#weight").text(jQuery("#weight-slider").slider("value"));
            jQuery("#goal").text(jQuery("#goal-slider").slider("value"));
            jQuery("#activity").text(jQuery("#activity-slider").slider("value"));
            jQuery("#diet").val(jQuery("#diet-slider").slider("value"));
            //$("#todatepicker .ui-datepicker-current-day a").trigger("click");
            refreshAll();
        }

        // Wait until after initialization then add inputs for age, height, weight, loss goal sliders
        setTimeout(function() {
            // Verify that the jQuery UI elements are loaded
            if(jQuery("#age-slider .ui-slider-handle").length) {
                // Initialize all inputs (dynamic text / arrows)
                initInputs();
                // Add event listeners to the up and down arrows for each input
                jQuery(".ui-slider-handle .up-arrow").click(function() {
                    var currValue = jQuery(this).parents(".ui-slider").slider("value");
                    jQuery(this).parents(".ui-slider").slider("value", currValue + 1);
                    if(jQuery(this).parents(".ui-slider").attr('id') === "height-slider") {
                        jQuery(this).parents(".ui-slider").siblings("p.input").text(convertHeight(currValue + 1));
                    } else {
                        jQuery(this).parents(".ui-slider").siblings("p.input").text(currValue + 1);
                    }
                    // Update all variables before recalculating each field
                    refreshAll();
                });
                jQuery(".ui-slider-handle .down-arrow").click(function() {
                    var currValue = jQuery(this).parents(".ui-slider").slider("value");
                    jQuery(this).parents(".ui-slider").slider("value", currValue - 1);
                    if(jQuery(this).parents(".ui-slider").attr('id') === "height-slider") {
                        jQuery(this).parents(".ui-slider").siblings("p.input").text(convertHeight(currValue - 1));
                    } else {
                        jQuery(this).parents(".ui-slider").siblings("p.input").text(currValue - 1);
                    }
                    // Update all variables before recalculating each field
                    refreshAll();
                });
            } else {
                setTimeout(initInputs, 100);
            }
        }, 10);

        // Adds inputs to each of the necessary fields
        function addInputs(sliderObject) {
            var id = sliderObject.attr('id');
            var inputId = id.split("-");
            var $upArrow = "<a href class='up-arrow'></a>";
            var $downArrow = "<a href class='down-arrow'></a>";
            //sliderObject.children(".ui-slider-handle").append($middleInput);
            sliderObject.children(".ui-slider-handle").append($upArrow);
            sliderObject.children(".ui-slider-handle").append($downArrow);
        }

        function checkGenderBox() {
            if(gender === "female") {
                var $femaleImage = "<img src='https://cdn.shopify.com/s/files/1/0557/8014/7381/t/18/assets/active.png?v=1650354014' draggable='false' />";
                var $maleImage = "<img src='https://cdn.shopify.com/s/files/1/0557/8014/7381/t/18/assets/not-active.png?v=1650354021' draggable='false' />";
                jQuery("input[value='female']").prop("checked", true);
                jQuery("#gender").empty().text("Female");
                jQuery(".male-button").empty().append($maleImage);
                jQuery(".female-button").empty().append($femaleImage);
            } else if(gender === "male") {
                var $maleImage = "<img src='https://cdn.shopify.com/s/files/1/0557/8014/7381/t/18/assets/active.png?v=1650354014' draggable='false' />";
                var $femaleImage = "<img src='https://cdn.shopify.com/s/files/1/0557/8014/7381/t/18/assets/not-active.png?v=1650354021' draggable='false' />";
                jQuery("input[value='male']").prop("checked", true);
                jQuery("#gender").empty().text("Male");
                jQuery(".female-button").empty().append($femaleImage);
                jQuery(".male-button").empty().append($maleImage);
            }
        }

        jQuery(".female-button").click(function() {
            var $checkedRadio = jQuery('input[name=gender]:checked', '.gender-section form').val();
            if($checkedRadio === "male") {
                gender = "female";
                jQuery("input[value='male']").prop("checked", false);
                checkGenderBox();
                saveVariables();
                calcDailyCalories();
            } else if($checkedRadio === "female") {

            }
        });
        jQuery(".male-button").click(function() {
            var $checkedRadio = jQuery('input[name=gender]:checked', '.gender-section form').val();
            if($checkedRadio === "female") {
                gender = "male";
                jQuery("input[value='female']").prop("checked", false);
                checkGenderBox();
                saveVariables();
                calcDailyCalories();
            } else if($checkedRadio === "male") {

            }
        });

        /* ACTIVITY SLIDER Dependencies:
            Updates TOTAL CALORIES & CALORIES PER DAY
            Not affected by other sliders
            Default: 50
        */
        var activity_select = jQuery( "#activity_select" );
        var activity_slider = jQuery("#activity-slider").slider({
            orientation: 'vertical',
            range: 'min',
            min: 1,
            max: 100,
            value: getVariables("activity", $activityValue, 50),
            slide: function(event, ui) {
                // Calculate activity level for male / female & recalculate calorie intake
                jQuery("#activity").text(ui.value);
                $activityValue = parseInt(jQuery("#activity").text());
                saveVariables();
                calcDailyCalories();
            }
        });
        jQuery( "#activity_select" ).on( "change", function() {
          var activity_value = jQuery(this).val();
          activity_slider.slider( "value", activity_value );
          jQuery("#activity").text(activity_value);
          $activityValue = parseInt(jQuery("#activity").text());
          saveVariables();
          calcDailyCalories();
        });
        //$("#activity").val($("#activity-slider").slider("value"));

        /* AGE SLIDER Dependencies:
            Updates TOTAL CALORIES & CALORIES PER DAY
            Not affected by other sliders
            Default: 30
        */
        var age_select = jQuery( "#age_select" );
        var age_slider = jQuery("#age-slider").slider({
            orientation: 'vertical',
            range: 'min',
            min: 20,
            max: 100,
            value: getVariables("age", $ageValue, 30),
            slide: function(event, ui) {
                // Updates age input with current slider value
                jQuery("#age").text(ui.value);
                $ageValue = parseInt(jQuery("#age").text());
                saveVariables();
                calcDailyCalories();
                jQuery(".bubble p:first-child").text(jQuery("#age").text());
            },

            stop: function(event, ui) {
                jQuery(".age-section .ui-slider-handle").css('background', 'transparent url("https://images.lifespanfitness.com/media/content/slider.png") no-repeat center center');
                jQuery(".age-section .ui-slider-handle").empty();
            }
        });
      
        jQuery("#age_select option[value= " + getVariables("age", $ageValue, 30) + "]").prop("selected",true).attr("selected","selected").trigger("change");    
        jQuery( "#age_select" ).on( "change", function() {
           var age_value = jQuery(this).val();
           age_slider.slider( "value", age_value );
           jQuery("#age").text(age_value);
           $ageValue = parseInt(jQuery("#age").text());
           saveVariables();
           calcDailyCalories();
           jQuery(".bubble p:first-child").text(jQuery("#age").text());
        });

        /* HEIGHT SLIDER Dependencies:
            Updates BMI, TARGET BMI, TOTAL CALORIES & CALORIES PER DAY
            Not affected by other sliders
            Default: 65 inches
        */
        var height_select = jQuery( "#height_select" );
        var height_slider = jQuery("#height-slider").slider({
            orientation: 'vertical',
            range: 'min',
            min: 58,
            max: 84,
            value: getVariables("height", $heightValue, 65),
            slide: function(event, ui) {
                // Updates height input with current slider value & recalculates BMI/calories
                jQuery("#height").text(convertHeight(ui.value));
                $heightValue = revertHeight(jQuery("#height").text());
                saveVariables();
                calcBMI(false);
                calcDailyCalories();
                jQuery(".bubble p:first-child").text(jQuery("#height").text());
            },
            stop: function(event, ui) {
                jQuery(".height-section .ui-slider-handle").css('background', 'transparent url("https://images.lifespanfitness.com/media/content/slider.png") no-repeat center center');
                jQuery(".height-section .ui-slider-handle").empty();
            }
        });
        
        jQuery("#height_select option[value= " + getVariables("height", $heightValue, 65) + "]").prop("selected",true).attr("selected","selected").trigger("change");    
        jQuery( "#height_select" ).on( "change", function() {
             var height_value = jQuery(this).val();
             height_slider.slider( "value", height_value );
             jQuery("#height").text(convertHeight(height_value));
             $heightValue = revertHeight(jQuery("#height").text());
             saveVariables();
             calcBMI(false);
             calcDailyCalories();
             jQuery(".bubble p:first-child").text(jQuery("#height").text());
          
         });

        /* WEIGHT SLIDER Dependencies:
            Updates BMI, TARGET BMI, TOTAL CALORIES & CALORIES PER DAY
            Not affected by other sliders
            Default: 130 lbs
        */
        var weight_select = jQuery( "#weight_select" );
        var weight_slider = jQuery("#weight-slider").slider({
            orientation: 'vertical',
            range: 'min',
            min: 100,
            max: 300,
            value: getVariables("weight", $weightValue, 130),
            slide: function(event, ui) {
                // Updates weight input with current slider value & recalculates BMI/calories
                jQuery("#weight").text(ui.value);
                setTimeout(function(){
                    $weightValue = parseInt(jQuery("#weight").text());
                    if(!(parseInt(jQuery("#goal").text()) <= $weightValue)) {
                        jQuery("#goal").text($weightValue - 1);
                        jQuery("#goal-slider").slider({value: $weightValue - 1});
                        $goalValue = $weightValue - parseInt(jQuery("#goal").text());
                        calcBMI(false);
                    } else {
                        calcBMI(true);
                    }

                }, 20);
                saveVariables();
                calcDailyCalories();
                jQuery(".bubble p:first-child").text(jQuery("#weight").text());
            },
            stop: function(event, ui) {
                jQuery(".weight-section .ui-slider-handle").css('background', 'transparent url("https://images.lifespanfitness.com/media/content/slider.png") no-repeat center center');
                jQuery(".weight-section .ui-slider-handle").empty();
            }
        });
      
    
        jQuery("#weight_select option[value= " + getVariables("weight", $weightValue, 130) + "]").prop("selected",true).attr("selected","selected").trigger("change");    
        jQuery( "#weight_select" ).on( "change", function() {
            var weight_value = jQuery(this).val();
            weight_slider.slider( "value", weight_value );
            // Updates weight input with current slider value & recalculates BMI/calories
            jQuery("#weight").text(weight_value);
            jQuery("#goal_select option").removeAttr("disabled","disabled");
            for(var i = weight_value; i <=300; i++){
              jQuery("#goal_select option[value= " + i + "]").attr("disabled","disabled");    
            }
            setTimeout(function(){
              $weightValue = parseInt(jQuery("#weight").text());

              if(!(parseInt(jQuery("#goal").text()) <= $weightValue)) {
                jQuery("#goal").text($weightValue - 1);
                localStorage.setItem('goal', parseInt($weightValue - 1));
                jQuery("#goal_select option[value= " + getVariables("goal", $weightValue - 1, $weightValue - 1) + "]").prop("selected",true).attr("selected","selected").trigger("change");    
                jQuery("#goal-slider").slider({value: $weightValue - 1});
                $goalValue = $weightValue - parseInt(jQuery("#goal").text());
                calcBMI(false);
              } else {
                calcBMI(true);
              }

            }, 20);
            saveVariables();
            calcDailyCalories();
            jQuery(".bubble p:first-child").text(jQuery("#weight").text());
         });

        /* GOAL SLIDER Dependencies:
            Updates TOTAL DAYS & BMI TARGET
            Not affected by other sliders
            Default: 5 lbs
        */
        var goal_select = jQuery( "#goal_select" );
        var goal_slider = jQuery("#goal-slider").slider({
            orientation: 'vertical',
            range: 'min',
            min: 100,
            max: 300,
            value: getVariables("goal", $goalWeight, 125),
            slide: function(event, ui) {
                // Updates goal input with current slider value & recalculates BMI/total days
                if(!(ui.value < $weightValue)) {
                    jQuery("#goal").text($weightValue - 1);
                    jQuery(this).slider({value: $weightValue - 1});
                    jQuery(".bubble p:first-child").text(jQuery("#goal").text());
                    return false;
                } else {
                    jQuery("#goal").text(ui.value);
                }
                $goalWeight = parseInt(jQuery("#goal").text());
                $goalValue = $weightValue - parseInt(jQuery("#goal").text());
                saveVariables();
                calcDailyCalories();
                calcBMI(false);
                calcTotalDays();
                jQuery(".bubble p:first-child").text(jQuery("#goal").text());
            },
            stop: function(event, ui) {
                jQuery(".goal-section .ui-slider-handle").css('background', 'transparent url("https://images.lifespanfitness.com/media/content/slider.png") no-repeat center center');
                jQuery(".goal-section .ui-slider-handle").empty();
            }
        });
      
        jQuery("#goal_select option[value= " + getVariables("goal", $goalWeight, 125) + "]").prop("selected",true).attr("selected","selected").trigger("change");    
        jQuery( "#goal_select" ).on( "change", function() {
            var goal_value = jQuery(this).val();
            goal_slider.slider( "value", goal_value );
            // Updates goal input with current slider value & recalculates BMI/total days
            if(!(goal_value < $weightValue)) {
              jQuery("#goal").text($weightValue - 1);
              jQuery(this).slider({value: $weightValue - 1});
              jQuery(".bubble p:first-child").text(jQuery("#goal").text());
              return false;
            } else {
              jQuery("#goal").text(goal_value);
            }
            $goalWeight = parseInt(jQuery("#goal").text());
            $goalValue = $weightValue - parseInt(jQuery("#goal").text());
            saveVariables();
            calcDailyCalories();
            calcBMI(false);
            calcTotalDays();
            jQuery(".bubble p:first-child").text(jQuery("#goal").text());
            
         });
      

        /* DIFFICULTY SLIDER Dependencies:
            Updates TOTAL DAYS & CALORIES PER DAY
            Not affected by other sliders
            Default: 23%
        */
        var difficulty_select = jQuery( "#difficulty_select" );
        var difficulty_slider = jQuery("#difficulty-slider").slider({
            orientation: 'horizontal',
            range: 'min',
            min: 1,
            max: 100,
            value: getVariables("difficulty", $difficultyValue, 23),
            slide: function(event, ui) {
                // Updates difficulty input with current slider value & recalculates total days/calories per day
                jQuery("#difficulty").val(ui.value);
                $difficultyValue = parseInt(jQuery("#difficulty").val());
                saveVariables();
                calcTotalDays();
                calcDailyCalories();
                calcDietRatio();
            }
        });
        jQuery("#difficulty").val(jQuery("#difficulty-slider").slider("value"));
      
        jQuery("#difficulty_select option[value= " + getVariables("difficulty", $difficultyValue, 23) + "]").prop("selected",true).attr("selected","selected").trigger("change");    
        jQuery( "#difficulty_select" ).on( "change", function() {
          var difficulty_value = jQuery(this).val();
          difficulty_slider.slider( "value", difficulty_value );
          jQuery("#difficulty").val(difficulty_value);
          $difficultyValue = parseInt(jQuery("#difficulty").val());
          saveVariables();
          calcTotalDays();
          calcDailyCalories();
          calcDietRatio();
        });
      
      

        /* DIET SLIDER Dependencies:
            Updates MODERATE EXERCISE, VIGOROUS EXERCISE, & DIET TOTAL
            Not affected by other sliders
            Default: 50%
        */
        var diet_select = jQuery( "#diet_select" );
        var diet_slider = jQuery("#diet-slider").slider({
            orientation: 'horizontal',
            range: 'min',
            min: -100,
            max: 0,
            value: getVariables("dietRatio", $dietRatio, -50),
            slide: function(event, ui) {
                // Updates diet input with current slider value & recalculate diet / exercise ratio
                jQuery("#diet").val(ui.value);
                calcDietRatio();
                saveVariables();
            }
        });
        jQuery("#diet").val(jQuery("#diet-slider").slider("value"));
      
        jQuery("#diet_select option[value= " + getVariables("dietRatio", $dietRatio, -50) + "]").prop("selected",true).attr("selected","selected").trigger("change");    
        jQuery( "#diet_select" ).on( "change", function() {
          var diet_value = jQuery(this).val();
          diet_slider.slider( "value", diet_value );
          jQuery("#diet").val(diet_value);
          calcDietRatio();
          saveVariables();
        });

        /* 	EXERCISE SLIDER Dependencies:
            Updates MODERATE EXERCISE & VIGOROUS EXERCISE
            Not affected by other sliders
            Default: 7 days
        */
        jQuery("#exercise-slider").slider({
            orientation: 'vertical',
            range: 'min',
            min: 1,
            max: 7,
            value: 7,
            slide: function(event, ui) {
                // Updates diet input with current slider value & recalculate diet / exercise ratio
                $("#exercise-days").val(ui.value);
                calcDietRatio();
                saveVariables();
            }
        });
        jQuery("#exercise-days").val(jQuery("#exercise-slider").slider("value"));


        /* ---- Variable declarations ---- */

        // Primary Variable initialization
        var gender = "female";
        var $heightValue = parseInt(jQuery("#height").text());
        var $weightValue = parseInt(jQuery("#weight").text());
        var $goalWeight = parseInt(jQuery("#goal").text());
        var $goalValue = $weightValue - parseInt(jQuery("#goal").text());
        var $ageValue = parseInt(jQuery("#age").text());
        var $difficultyValue = parseInt(jQuery("#difficulty").val());
        var $dietRatio = jQuery("#diet").val() / 100;
        var $activityValue = jQuery("#activity-slider").slider("value");

        /* BMI SLIDER Dependencies:
            Does not update any sliders - deactivated
            Affected by HEIGHT, WEIGHT, & LOSS GOAL
            Defaults: 22.3 & 20.9
        */
        jQuery("#bmi-slider").slider({
            orientation: 'horizontal',
            range: true,
            min: 12,
            max: 48,
            values: [22.3, 20.9],
            disabled: true
        });
        jQuery("#bmi").text(Math.round(bmiForm() * 10) / 10);

        /* ---- Formula Calculations ---- */

        function bmiForm() {
            return (703 * $weightValue)/($heightValue * $heightValue);
        }
        function targetForm() {
            return (703 * ($weightValue - $goalValue))/($heightValue * $heightValue);
        }
        function dailyLossForm() {
            return ($goalValue * 3500) / totalDaysForm();
        }
        function dailyCalorieForm() {
            if(gender === "male") {
                return 662 - (9.53 * $ageValue) + activityForm() * ((15.91 * $weightValue / 2.205) + (539.6 * $heightValue * 2.54 / 100));
            } else if(gender === "female") {
                return 354 - (6.91 * $ageValue) + activityForm() * ((9.36 * $weightValue / 2.205) + (726 * $heightValue * 2.54 / 100));
            }
        }
        function totalDaysForm() {
            return $goalValue * 3500 / (($difficultyValue / 100) * dailyCalorieForm());
        }
        function activityForm() {
            return .00002 * $activityValue * $activityValue + .0027 * $activityValue + 1;
        }
        function weightLossRateForm() {
            return (($goalValue * 3500) / $("#days").text(Math.round(totalDaysForm()))) / $("#calsperday").val(Math.round(dailyLossForm()));;
        }

        // Function that re-checks all variables & formulas
        function refreshAll() {
            $heightValue = revertHeight(jQuery("#height").text());
            $weightValue = parseInt(jQuery("#weight").text());
            $goalValue = $weightValue - parseInt(jQuery("#goal").text());
            $ageValue = parseInt(jQuery("#age").text());
            $activityValue = parseInt(jQuery("#activity").text());
            calcDailyCalories();
            calcTotalDays();
            calcDietRatio();
            calcBMI(false);
        }

        // Converts the height value to display as feet / inches
        function convertHeight(value) {
            var feet = Math.floor(value / 12);
            var inches = value % 12;

            return feet + "\' " + inches + "\"";
        }

        // Reverts the feet and inches format to calculate properly
        function revertHeight(value) {
            var heightArray = value.split("'");
            var inchArray = heightArray[1].split("\"");
            var inchTotal = parseInt(heightArray[0] * 12) + parseInt(inchArray[0]);

            return inchTotal;
        }

        // Formula calculates the bmi based on height and weight
        function calcBMI(weightSlider) {
            jQuery("#bmi").text(Math.round(bmiForm() * 10) / 10);
            jQuery("#bmi-slider").slider("values", 0, bmiForm());
            if (!weightSlider) {
                jQuery("#bmi-slider").slider("values", 1, targetForm());
            }
        }

        // Formula calculates the number of calories
        function calcDailyCalories() {
            // Apply the formula result to the daily calorie input field
            jQuery("#daily").val(dailyCalorieForm());
            jQuery("#calsperday").val(Math.round(dailyLossForm()));
            calcTotalDays();
            calcDietRatio();
        }

        // Function to determine ratio of exercise to diet
        function calcDietRatio() {
            $weightValue = parseInt(jQuery("#weight").text());
            $dietRatio = Math.abs(jQuery("#diet").val() / 100);
            var exerciseDays = jQuery("#exercise-days").val();
            var dietTotal = dailyLossForm();
            var modTotal = Math.round(60 * (dietTotal / ($weightValue / 2.2)) / 4.5);
            var vigTotal = Math.round(60 * (dietTotal / ($weightValue / 2.2)) / 7);
            var dietFormula = Math.floor($dietRatio * dietTotal);
            var consumeFormula = dailyCalorieForm() - dietFormula;
            var modFormula = (1 - $dietRatio) * modTotal;
            var vigFormula = (1 - $dietRatio) * vigTotal;
            var finalModFormula = 7 / exerciseDays * modFormula;
            var finalVigFormala = 7 / exerciseDays * vigFormula;
            var exerciseFormula = (7 / exerciseDays) * (1 - $dietRatio) * dietTotal;

            jQuery("#diet-data").text(dietFormula);
            jQuery("#diet-counter").text(Math.abs(jQuery("#diet").val()) + "%");
            jQuery("#exercise-counter").text(Math.abs(Math.abs(jQuery("#diet").val()) - 100) + "%");
            calcFoodIntake();

            // Populate inputs for total consumption / exercise sections
            jQuery("#consume").text(Math.floor(consumeFormula));
            jQuery("#moderate").text(Math.round(finalModFormula));
            jQuery("#vigorous").text(Math.round(finalVigFormala));

            // Populate inputs for total walking / running miles per day
            jQuery("#mod-miles").text(Math.round((exerciseFormula / 80) * 10) / 10);
            jQuery("#vig-miles").text(Math.round((exerciseFormula / 118) * 10) / 10);
        }

        // Function to determine the amount of food to remove from diet per day
        function calcFoodIntake() {
            var chickenForm = Math.ceil(parseInt(jQuery("#diet-data").text()) / 210);
            var cookieForm = Math.ceil(parseInt(jQuery("#diet-data").text()) / 80);
            var beerForm = Math.ceil(parseInt(jQuery("#diet-data").text()) / 150);

            jQuery("#chicken").text(chickenForm);
            jQuery("#cookies").text(cookieForm);
            jQuery("#beer").text(beerForm);
        }

        // Function to determine total number of days to lose goal weight
        function calcTotalDays() {
            jQuery("#days").text(Math.round(totalDaysForm()));
            totalDays = parseInt(jQuery("#days").text());
            dayChange = Math.abs(totalDays) - Math.abs(dayDifference);
            //$("#todatepicker").datepicker("setDate", $("#days").val());
            updateToDate();
        }

        // Function to determing the difficulty value
        function calcDifficulty() {
            $difficultyValue = Math.round((($goalValue * 3500 / Math.abs(dayDifference))/dailyCalorieForm()) * 100);
            jQuery("#difficulty-slider").slider("value", $difficultyValue);
            jQuery("#difficulty").val(jQuery("#difficulty-slider").slider("value"));
            saveVariables();
        }

        /* ---- Date Handling Section ---- */

        var oneDay = 24*60*60*1000;
        var totalDays = Math.round(totalDaysForm());
        var fromDate = new Date();
        var toDate = new Date();
        var dayDifference = Math.round((fromDate.getTime() - toDate.getTime())/oneDay);
        var dayChange = Math.abs(totalDays) - Math.abs(dayDifference);

        // Set up the datepicker for the range beginning, which defaults to today with the month highlighted through & disabled
        jQuery("#fromdatepicker").datepicker({minDate: 0, defaultDate: fromDate.setHours(0,0,0,0),
            onSelect: function(dateText, inst) {
                fromDate = jQuery(this).datepicker("getDate");
                if(toDate <= fromDate) {
                    toDate.setTime(fromDate.getTime() + oneDay);
                    jQuery("#todatepicker").datepicker("setDate", toDate);
                }
                dayDifference = Math.floor((fromDate.getTime() - toDate.getTime())/oneDay);
                dayChange = Math.abs(totalDays) - Math.abs(dayDifference);
                calcTotalDays();
                calcDifficulty();
                jQuery("#todatepicker").datepicker("refresh");
                refreshAll();
            },
            beforeShowDay: function(date) {
                return [true, ((date >= fromDate && date <= toDate) ? 'ac-active' : '')];
            }
        });
        jQuery("#fromdatepicker").datepicker('setDate', fromDate);
        // Setting up the datepicker for the range end, which defaults to today's date plus the toDate information
        jQuery("#todatepicker").datepicker({minDate: fromDate, defaultDate: toDate,
            onSelect: function(dateText, inst) {
                toDate = jQuery(this).datepicker("getDate");
                if(toDate <= fromDate) {
                    toDate.setTime(fromDate.getTime() + oneDay);
                    jQuery("#todatepicker").datepicker("setDate", toDate);
                }
                dayDifference = Math.floor((fromDate.getTime() - toDate.getTime())/oneDay);
                dayChange = Math.abs(totalDays) - Math.abs(dayDifference);
                calcDifficulty();
                refreshAll();
            },
            beforeShowDay: function(date) {
                return [true, ((date >= fromDate && date <= toDate) ? 'ac-active' : '')];
            }
        });

        // Datepicker dynamic styling for the to date calendar
        function updateToDate() {
            toDate.setDate(toDate.getDate() + dayChange);
            dayDifference = totalDays;
            jQuery("#fromdatepicker").datepicker("refresh");
            jQuery("#todatepicker").datepicker("setDate", toDate);
            setTimeout(function() {
                jQuery("#fromdatepicker .ui-datepicker-current-day a.ui-state-active").css("font-size", "12px");
                jQuery("#todatepicker .ui-datepicker-current-day a.ui-state-active").css("font-size", "12px");
            }, 1);
        }

        // Add click events for the additional "How it works" page and back to the calculator
        jQuery("#how-link").click(function(event) {
            event.preventDefault();
            jQuery(".ac-app-container").animate({
                right: 960
            }, 1000);
            jQuery(".ac-text-container").animate({
                left: 0
            }, 1000);
        });
        jQuery("#back-link").click(function(event) {
            event.preventDefault();
            jQuery(".ac-text-container").animate({
                left: 960
            }, 1000);
            jQuery(".ac-app-container").animate({
                right: 0
            }, 1000);
        });

        // Add click event to the slider handles that populates a balloon and adds dynamic input text
        jQuery(".age-section .ui-slider-handle").on('mousedown', function() {
            var $badge = "<div class='bubble'><p>" + jQuery(this).parent(".ui-slider").siblings("#age").text() + "</p><div class='arrow'></div></div>";
            jQuery(this).css('background', 'none');
            jQuery(this).empty();
            jQuery(this).append($badge);
            jQuery(".bubble p:first-child").text(jQuery("#age").text());
        });

        jQuery(".height-section .ui-slider-handle").on('mousedown', function() {
            var $badge = "<div class='bubble'><p>" + jQuery(this).parent(".ui-slider").siblings("#height").text() + "</p><div class='arrow'></div></div>";
            jQuery(this).css('background', 'none');
            jQuery(this).empty();
            jQuery(this).append($badge);
            jQuery(".bubble p:first-child").text(jQuery("#height").text());
        });

        jQuery(".weight-section .ui-slider-handle").on('mousedown', function() {
            var $badge = "<div class='bubble'><p>" + jQuery(this).parent(".ui-slider").siblings("#weight").text() + "</p><div class='arrow'></div></div>";
            jQuery(this).css('background', 'none');
            jQuery(this).empty();
            jQuery(this).append($badge);
            jQuery(".bubble p:first-child").text(jQuery("#weight").text());
        });

        jQuery(".goal-section .ui-slider-handle").on('mousedown', function() {
            var $badge = "<div class='bubble'><p>" + jQuery(this).parent(".ui-slider").siblings("#goal").text() + "</p><div class='arrow'></div></div>";
            jQuery(this).css('background', 'none');
            jQuery(this).empty();
            jQuery(this).append($badge);
            jQuery(".bubble p:first-child").text(jQuery("#goal").text());
        });

    };

